import {observable, computed, action, reaction, autorun} from 'mobx';

export class Persist {
  constructor(sessionStorage, vMaster, searchForm) {
    this._sessionStorage = sessionStorage;
    this._vMaster = vMaster;
    this._searchForm = searchForm;
  }

  @action.bound startReactions() {
    autorun(() => {
      const {view, orgId, objId, trxId} = this._vMaster;
      //if(orgId) this._sessionStorage.setState({orgId});

      const {
        location, 
        categoryReal: category, 
        subcategoryReal: subcategory, 
        startDate, 
        durationReal: duration,
        timeUnitReal: timeUnit,
      } = this._searchForm;

      this._sessionStorage.setState({
        organizationId: orgId,
        objectId: objId,
        transactionId: trxId,
        searchLocation: location,
        searchCategory: category,
        searchSubcategory: subcategory,
        searchStartDate: startDate,
        searchDuration: duration,
        searchTimeUnit: timeUnit,
      })
    })
  }
}


// WEBPACK FOOTER //
// ./src/model/Persist.js